module.exports = __webpack_public_path__ + "img/facebook.9c3c390b.svg";